import { Link } from "react-router-dom";

/**
 * DRAFT. The wording below is a reasonable starting point, not legal advice --
 * it needs review by the university's privacy officer before launch, and the
 * contact address is a placeholder.
 */
export default function Privacy() {
  return (
    <div className="mx-auto max-w-3xl">
      <h1 className="text-3xl font-semibold text-heading">Privacy statement</h1>
      <p className="mt-2 text-sm text-uoa-grey">Draft — pending review. Last updated 3 September 2026.</p>

      <div className="mt-8 space-y-8">
        <Section title="What we collect">
          <p>When you use Intern-Seek we collect:</p>
          <List items={[
            "Your name, university email address and student ID.",
            "Your specialisation and year of study.",
            "The CV you upload, and any information contained in it.",
            "The positions you apply for and any cover notes you write.",
            "References that academic staff provide about you at your request.",
            "Sign-in times and a record of who accesses your CV.",
          ]} />
        </Section>

        <Section title="Why we collect it">
          <p>
            To operate the internship placement programme: to let employers assess your suitability for
            positions you apply to, to let academic staff provide references you have asked for, and to
            let the internship coordinator administer the programme.
          </p>
        </Section>

        <Section title="Who can see your information">
          <List items={[
            "Employers see your name, specialisation and year of study once you submit an expression of interest.",
            "An employer can only see your CV and contact details after you apply to one of their positions.",
            "Academic staff you nominate as a referee can see your profile and CV.",
            "The internship coordinator can see all of the above in order to administer the programme.",
            "References are confidential by default. You will not be able to read a reference unless the referee chooses to share it with you.",
          ]} />
        </Section>

        <Section title="Where it is stored">
          <p>
            Your information is stored on servers located in Australia (AWS Asia Pacific, Sydney) and is
            not transferred outside Australia or New Zealand.
          </p>
        </Section>

        <Section title="How long we keep it">
          <p>
            Your account and the information attached to it are removed after two years of inactivity.
            You may ask the internship coordinator to remove your information sooner.
          </p>
        </Section>

        <Section title="Your rights">
          <p>
            Under the Privacy Act 2020 you may ask to see the personal information we hold about you and
            request corrections to it. Reference content provided in confidence may be withheld.
            Contact the internship coordinator to make a request.
          </p>
        </Section>

        <Section title="Contact">
          {/* TODO: replace with the real coordinator address before launch. */}
          <p>Internship Coordinator, Faculty of Engineering — internships@aucklanduni.ac.nz</p>
        </Section>
      </div>

      <p className="mt-10">
        <Link to="/" className="text-uoa-blue underline dark:text-uoa-blue-light">Back</Link>
      </p>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section>
      <h2 className="mb-2 text-lg font-semibold text-heading">{title}</h2>
      <div className="space-y-2 text-sm leading-relaxed">{children}</div>
    </section>
  );
}

function List({ items }: { items: string[] }) {
  return (
    <ul className="list-disc space-y-1 pl-5">
      {items.map((item) => <li key={item}>{item}</li>)}
    </ul>
  );
}
